import React, {useEffect, useState} from 'react';
// import { nanoid } from 'nanoid';
import { v4 as uuidv4 } from 'uuid';
import './App.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment-timezone';
import Api from './lib/Api';
import { services } from './lib/services';
import { ServiceGroup } from './lib/models';

function App() {

  const [timeSlots, setTimeSlots] = useState<string[]>(["9:00 AM - 10:00 AM", "2:00 PM - 3:00 PM"]);

  const [formHasError, setFormHasError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [messageColor, setMessageColor] = useState("green");
  const [serviceArray, setServiceArray] = useState<number[]>([]);
  
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [comments, setComments] = useState("");

  const [selectedService, setSelectedService] = useState("");
  const [selectedServiceIndex, setSelectedServiceIndex] = useState<number[]>([]);
  const [selectedSubServices, setSelectedSubServices] = useState<ServiceGroup[]>();
  const [selectedApptDate, setSelectedApptDate] = useState("");
  const [selectedAppTime, setSelectedAppTime] = useState("");
  
  const [minDate, setMinDate] = useState("");
  const [maxTime, setMaxTime] = useState("18:00");


  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [makeError, setMakeError] = useState("");
  const [modelError, setModelError] = useState("");
  const [yearError, setYearError] = useState("");
  const [serviceError, setServiceError] = useState("");
  const [apptDateError, setApptDateError] = useState("");
  const [apptTimeError, setApptTimeError] = useState("");
  const [timeSlotError, setTimeSlotError] = useState("");

  useEffect(() => {
    let today = new Date();
    let opening = new Date("04/21/2026");

    if(today < opening)
      setMinDate(opening.toISOString().split('T')[0]);
    else
      setMinDate(today.toISOString().split('T')[0]);

  }, []);

  useEffect(() => {
    if(selectedApptDate != "") {
      let x = moment(selectedApptDate).tz("America/New_York");
      
      if(x.day() == 6)
        setMaxTime("13:00");
      else
        setMaxTime("18:00");
    }
  }, [selectedApptDate])


  function generateTimeSlots(selectedDate: string) {
    setSelectedApptDate(selectedDate)
    const closingHour = 19;
    const timeFrame = 2;
    const currentTime = moment().tz("America/New_York");
    const currentHour = currentTime.hour() + 1; // +1 to account for a min of 1 hour of anticipation time.
    const interval = closingHour - currentHour;
    const slots = Math.trunc(interval/timeFrame);
    let _timeSlots = [];

    console.log(`closingHour: ${closingHour}`);
    console.log(`currentTime.hour(): ${currentHour}`);
    console.log(`interval: ${interval}`);
    console.log(`timeFrame: ${timeFrame}`);
    console.log(`slots: ${slots}`);


    if(interval > timeFrame) {
      for(let i=0; i < slots; i++) {
        _timeSlots.push(`${(currentHour%12) + (i * timeFrame)}:00 ${currentTime.format('a')} - ${((currentHour+timeFrame)%12) + (i * timeFrame)}:00 ${currentTime.format('a')}`);
        console.log(`${(currentHour%12) + (i * timeFrame)}:00 ${currentTime.format('a')} - ${((currentHour+timeFrame)%12) + (i * timeFrame)}:00 ${currentTime.format('a')}`);
      }
    }

    setTimeSlots([..._timeSlots]);

  }

  function onDateChange(e: any) {
    let selectedDate = moment(e.target.value).tz("America/New_York");
    // check if sunday
    if(selectedDate.day() != 0) {
      setSelectedApptDate(e.target.value);
      setApptDateError("");
      setFormHasError(false);
    }
    else {
      setSelectedApptDate("");
      setApptDateError("Please select any other day of the week. There's no service on Sundays.");
      setFormHasError(true);
    }
  }

  function serviceChange(index:number, serviceIndex: number) {
    const _selectedServiceIndex = [...selectedServiceIndex];
    _selectedServiceIndex[index] = serviceIndex;
    setSelectedServiceIndex(_selectedServiceIndex);
    // setSelectedService(e.target.value)
    // setSelectedServiceIndex(serviceIndex);
    // setSelectedService(serviceIndex.toString());
  }

  function showMobileMenu() {
    document.querySelector('nav')?.classList.toggle('active');
  }

  async function submitAppointment(e: any) {
    e.preventDefault();
    setSubmitMessage("");
    setIsSubmitting(true);

    let _formHasError = false;

    if(!fullName || fullName == "") {
      _formHasError = true;
      setNameError("Your name is required.");
    }
    else {
      setNameError("");
    }

    if(!email || email == "") {
      _formHasError = true;
      setEmailError("An email is required.");
    }
    else {
      setEmailError("");
    }
    
    if(!phone || phone == "") {
      _formHasError = true;
      setPhoneError("A phone number is required.");
    }
    else {
      setPhoneError("");
    }

    if(!make || make == "") {
      _formHasError = true;
      setMakeError("Your car's make is required.");
    }
    else {
      setMakeError("");
    }

    if(!model || model == "") {
      _formHasError = true;
      setModelError("Your car's model is required.");
    }
    else {
      setModelError("");
    }
     
    if(!year || parseInt(year) == 0) {
      _formHasError = true;
      setYearError("Your car's year is required.");
    }
    else {
      setYearError("");
    }

    // {Name: "", SubServices: []}
    let serviceList: ServiceGroup[] = [];
    if(!selectedServiceIndex || selectedServiceIndex.length == 0) {
      _formHasError = true;
      setServiceError("A service is required.");
    }
    else {
      setServiceError("");
      for(let i=0; i < selectedServiceIndex.length; i++) {
        const selectedServiceGroup = services.Services[selectedServiceIndex[i]];
        const selectedSubServices = document.getElementsByName(selectedServiceGroup.Name.replaceAll(" ", "").toLowerCase());
        // serviceList.Name = selectedServiceGroup.Name;
        let _subServices = [];
        for(let i= 0; i < selectedSubServices.length; i++) {
          const _sub = (selectedSubServices[i] as HTMLInputElement);
          if(_sub.checked) {
            // serviceList.SubServices.push({ Name: _sub.value });
            _subServices.push({ Name: _sub.value });
          }
        }

        serviceList.push({
          Name: selectedServiceGroup.Name,
          SubServices: _subServices
        })
      }
    }

    if(!selectedApptDate || selectedApptDate == "") {
      _formHasError = true;
      setApptDateError("An appointment date is required.");
    }
    else {
      setApptDateError("");
    }

    if(!selectedAppTime || selectedAppTime == "") {
      _formHasError = true;
      setApptTimeError("An appointment time is required.");
    }
    else {
      setApptTimeError("");
    }

    setFormHasError(_formHasError);

    if(!_formHasError) {
      e.preventDefault();
      // gather data
      // crypto.randomUUID()
      const appointment = {
        AppointmentId: "9c90d626-5b3f-4a39-8aaa-97ef7f8a995b", // UAC fixed partition key
        Timestamp: moment().tz("America/New_York").valueOf(),
        FullName: fullName,
        Email: email,
        Phone: phone,
        Make: make,
        Model: model,
        Year: parseInt(year),
        Services: {
          Services: serviceList
        },
        Comments: comments,
        Done: false,
        Deleted: false,
        AppointmentTime: selectedAppTime,
        AppointmentDate: selectedApptDate,
      }

      try {
        await Api.addAppointment(appointment);
        setSubmitMessage("Appointment Scheduled.");
        setMessageColor("green");

        setFullName("");
        setEmail("");
        setPhone("");
        setMake("");
        setModel("");
        setYear("");
        // setSelectedService("-1");
        setServiceArray([]);
        setSelectedServiceIndex([]);
        setSelectedApptDate("");
        setSelectedAppTime("");
        setComments("");

        setTimeout(() => {
          if(process.env.REACT_APP_HOME_URL)
            document.location = process.env.REACT_APP_HOME_URL;
        }, 2500);


      } catch (error) {
        setSubmitMessage("There was an error scheduling the appointment. Please try again later.");
        setMessageColor("red");
      }

    }

    setIsSubmitting(false);

  }


  return (
    <>
      <div className="top-bar">
          <div className="title">
              <div><a href={process.env.REACT_APP_HOME_URL}><img src="https://d36avpsn8df2cg.cloudfront.net/img/uac_logo.png" width={100} /></a></div>
              <div><h1 style={{fontSize: "1.8rem"}}>Upgrade Auto Care</h1></div>
          </div>
          <div className="mobile-menu">
            <FontAwesomeIcon icon={faBars} onClick={() => showMobileMenu()} />
          </div>
          <nav>
              <ul>
                  <li><a className='btn' href={process.env.REACT_APP_HOME_URL}>Back to Home Page</a></li>
              </ul>
          </nav>
      </div>
      <br />
      <div className='form-container'>
        <div className='form-item'>
          <div className='contact-form'>
            <form onSubmit={async (e) => await submitAppointment(e)}>
              <div className='form-group'>
                <h1>Schedule an Appointment</h1>
              </div>
              <br />
              <div className='form-group'>
                <label htmlFor='name'>Full Name <span style={{color: "red"}}>*</span></label>
                <input required autoComplete='off' onChange={(e) => setFullName(e.target.value)} value={fullName} type='text' id="name" placeholder='Enter your name...' />
                {formHasError && nameError != ""? <><span style={{color: "red"}}>{nameError}</span></> : <></>}
              </div>
              <div className='form-group'>
                <label htmlFor='email'>Email <span style={{color: "red"}}>*</span></label>
                <input required type='email' onChange={(e) => setEmail(e.target.value)} value={email} autoComplete='email' id="email" placeholder='you@example.com' />
                {formHasError && emailError != ""? <><span style={{color: "red"}}>{emailError}</span></> : <></>}
              </div>
              <div className='form-group'>
                <label htmlFor='phone'>Phone Number <span style={{color: "red"}}>*</span></label>
                {/* pattern='[0-9]{3}-[0-9]{3}-[0-9]{4}' */}
                <input required type='tel' onChange={(e) => setPhone(e.target.value)} value={phone} maxLength={10} autoComplete='tel' id="phone" placeholder='Example: 4071234567' />
                {formHasError && phoneError != ""? <><span style={{color: "red"}}>{phoneError}</span></> : <></>}
              </div>
              <div className='form-group'>
                <label htmlFor='make'>Make <span style={{color: "red"}}>*</span></label>
                <input required type='text' onChange={(e) => setMake(e.target.value)} value={make} autoComplete='off' id="make" placeholder="Enter your car's make..." />
                {formHasError && makeError != ""? <><span style={{color: "red"}}>{makeError}</span></> : <></>}
              </div>
              <div className='form-group'>
                <label htmlFor='model'>Model <span style={{color: "red"}}>*</span></label>
                <input required type='text' onChange={(e) => setModel(e.target.value)} value={model} autoComplete='off' id="model" placeholder="Enter your car's model..." />
                {formHasError && modelError != ""? <><span style={{color: "red"}}>{modelError}</span></> : <></>}
              </div>
              <div className='form-group'>
                <label htmlFor='year'>Year <span style={{color: "red"}}>*</span></label>
                <input required type='number' onChange={(e) => setYear(e.target.value)} value={year} maxLength={4} minLength={4} autoComplete='off' id="year" placeholder='Example: 2005' />
                {formHasError && yearError != ""? <><span style={{color: "red"}}>{yearError}</span></> : <></>}
              </div>
              <div className='form-group'>
                <label htmlFor='services'>Services <span style={{color: "red"}}>*</span>&nbsp;<a onClick={() => {
                  let _serviceArray = [...serviceArray];
                  _serviceArray.push(1);
                  setServiceArray(_serviceArray);
                }} role='button' style={{cursor: "pointer", color: "#0000EE"}}>Add Service</a></label>
                {
                  serviceArray.map((s, i) => {
                    return (
                      <div key={`service_${i}`}>
                        <select onChange={(e) => serviceChange(i, parseInt(e.target.value))} value={selectedServiceIndex[i]} id="services" name="services">
                          <option value="-1">Select a service...</option>
                          {
                            services.Services.map((service: ServiceGroup, idx: number) => {
                              return (
                                <option key={`service_${i}_${idx}`} value={idx}>{service.Name}</option>
                              )
                            })
                          }
                        </select>
                        <br />
                        {
                          selectedServiceIndex[i] > -1 && services.Services[selectedServiceIndex[i]]?
                          <>
                            <br />
                            {
                              services.Services[selectedServiceIndex[i]].SubServices.map((subService, idx2) => {
                                return (
                                  <div key={`service_${i}_${selectedServiceIndex[i]}_sub_${idx2}`}>
                                    <input type='checkbox' name={`${services.Services[selectedServiceIndex[i]].Name.replaceAll(" ", "").toLowerCase()}`} value={subService.Name} />{subService.Name}
                                  </div>
                                )
                              })
                            }
                          </>: <></>
                        }
                        <br />
                      </div>
                    )
                  })
                  
                }
                {formHasError && serviceError != ""? <><span style={{color: "red"}}>{serviceError}</span></> : <></>}
              </div>
              {/* <div className='form-group'>
                <label htmlFor='consultationDate'>Appointment Date</label>
                <input type='date' required id="consultationDate" onChange={(e) => generateTimeSlots(e.target.value)} />
                {formHasError && apptDateError != ""? <><span style={{color: "red"}}>{apptDateError}</span></> : <></>}
              </div> */}
              <div className='form-group'>
                <label htmlFor='consultationDate'>Appointment Date <span style={{color: "red"}}>*</span></label>
                <input type='date' required id="consultationDate" min={minDate} onChange={(e) => onDateChange(e)} value={selectedApptDate} />
                <br />
                {formHasError && apptDateError != ""? <><span style={{color: "red"}}>{apptDateError}</span></> : <></>}
                <br />
                <span style={{fontSize: 12, color: "#687078"}}>This date may change depending on availability. Upgrade Auto Care will work with you to confirm the best date for both.</span>
              </div>
              <div className='form-group'>
                <label htmlFor='consultationTime'>Appointment Time <span style={{color: "red"}}>*</span></label>
                <input type="time" id="consultationTime" value={selectedAppTime} onChange={(e) => setSelectedAppTime(e.target.value)} name="consultationTime" min="09:00" max={maxTime} required />
                <br />
                {formHasError && apptTimeError != ""? <><span style={{color: "red"}}>{apptTimeError}</span></> : <></>}
                <br />
                <span style={{fontSize: 12, color: "#687078"}}>The time may change depending on availability. Upgrade Auto Care will work with you to confirm the best time for both.</span>
              </div>
              {/* {
                selectedApptDate != ""?
                <>
                  <div className='form-group'>
                    <label htmlFor='time-slots'>Time Slots</label>
                    <div style={{display: "flex", flexDirection: "row", columnGap: 10}}>
                      {
                        timeSlots.map((e, i) => {
                          return <div key={`time-slot-${i}`} className='time-slot-item'>{e}</div>
                        })
                      }
                    </div>
                    {formHasError && timeSlotError != ""? <><span style={{color: "red"}}>{timeSlotError}</span></> : <></>}
                  </div>
                </> : <></>
              } */}
              <div className='form-group'>
                <label htmlFor='comments'>Comments</label>
                <textarea id="comments" maxLength={8000} onChange={(e) => setComments(e.target.value)} value={comments} placeholder='Your comments here...'></textarea>
              </div>
              <div className='form-group'>
                <button type="submit" className="btn">{isSubmitting? <div className='spinner'></div> : <>Schedule</>} </button>
                {
                  submitMessage != ""?
                  <>
                    &nbsp;
                    <span style={{color: messageColor}}>{submitMessage}</span>
                  </>: <></>
                }
              </div>
              <br />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
